import { render, staticRenderFns } from "./DeletedFormatSelector.vue?vue&type=template&id=6f5f84f1&scoped=true&"
import script from "./DeletedFormatSelector.vue?vue&type=script&lang=ts&"
export * from "./DeletedFormatSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DeletedFormatSelector.vue?vue&type=style&index=0&id=6f5f84f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f84f1",
  null
  
)

export default component.exports